import { Link, Typography } from "@mui/material";
import React from "react";
import { footerRoutesData } from "../../../constants";
import Gene20Box from "../../Gene20Box/Gene20Box";

export default function FooterNavigation() {
  return (
    <Gene20Box
      component="ul"
      justifyContent="center"
      alignItems="center"
      sx={({ breakpoints }) => ({
        display: "flex",
        flexWrap: "wrap",
        listStyle: "none",
        mt: 2,
        mb: 1,
        p: 0,

        [breakpoints.up("lg")]: {
          mt: 0,
        },
      })}
    >
      {footerRoutesData.map((link) => (
        <Gene20Box
          key={link.name}
          component="li"
          display="flex"
          justifyContent="center"
          alignItems="center"
          flexWrap="wrap"
          sx={{ fontSize: (theme) => theme.typography.size.sm }}
          px={1.5}
          marginTop="3"
          lineHeight={1}
        >
          <Link href={link.href}>
            <Typography
              variant="button"
              sx={{
                fontSize: (theme) => theme.typography.size.sm,
                fontWeight: (theme) => theme.typography.size.fontWeightLight,
              }}
              color="secondary"
            >
              &nbsp; {link.name}
            </Typography>
          </Link>
        </Gene20Box>
      ))}
    </Gene20Box>
  );
}
